module.exports = __webpack_public_path__ + "img/power.b119e5d4.png";